<template>
  <div v-html="htmlContent"></div>
</template>

<script>
import axios from 'axios';
import markdownIt from 'markdown-it';

const md = new markdownIt();

export default {
  name: 'MarkdownViewer',
  data() {
    return {
      htmlContent: ''
    };
  },
  async created() {
    const command = this.$route.params.command || 'index';
    console.log('MarkdownViewer.vue created for command:', command); // Log the command
    try {
      // Update path to correctly fetch index.json from /md/linux-commands/
      const filePath = command === 'index' ? `/md/linux-commands/index.json` : `/md/linux-commands/${command}.md`;
      const response = await axios.get(filePath);
      console.log('Response headers:', response.headers); // Log the full headers
      console.log('Response content:', response.data); // Log the response content

      if (command === 'index' && response.headers['content-type'].includes('application/json')) {
        const markdownContent = response.data.markdown || '';
        this.htmlContent = md.render(markdownContent);
        console.log('Markdown content loaded for command:', command); // Log successful load
      } else if (response.headers['content-type'].includes('text/markdown') || response.headers['content-type'].includes('text/plain')) {
        this.htmlContent = md.render(response.data);
        console.log('Markdown content loaded for command:', command); // Log successful load
      } else {
        this.htmlContent = `Unexpected content type: ${response.headers['content-type']}. Please check the server configuration.`;
      }
    } catch (error) {
      this.htmlContent = 'File not found';
      console.error('Error fetching file in MarkdownViewer.vue:', error);
    }
  }
};
</script>

<style scoped>
div {
  padding: 1rem;
  background-color: #f5f5f5;
  color: #333;
  border-radius: 8px;
}
</style>
